<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">分账记录</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <span>1.仅对游客、会员产生的订单消费进行分账（扣除交易手续费后），企业员工类别的会员所产生的订单不进行分账，请线下与企业进行结算；<br />
        <span>2.如要统计某月产生的收益到账金额，请将下列转账日期的起止和终止日期向后推迟1天，如统计2022年2月收益到账金额，则选为2022.2.2至2022.3.1（因为1号产生的收益，转账日期为2号）</span
        >
      </span>
    </div>
    <div class="filter-box">
      <div style="display: flex; align-items: center">
        <span class="subtitle">分账单号:</span>
        <Input
          v-model="page.id"
          placeholder="请输入分账单号"
          style="width: 260px; margin: 0 10px"
        />
        <span class="subtitle">收款人ID:</span>
        <Input
          v-model="page.dispense_id"
          placeholder="请输入收款人ID"
          style="width: 130px; margin: 0 10px"
        ></Input>
        <span class="subtitle">收款人:</span>
        <Input
          v-model="page.dispense_name"
          placeholder="请输入收款人"
          style="width: 210px; margin: 0 10px"
        ></Input>
        <span class="subtitle" style="margin-left: 10px">收款方式:</span>
        <Select
          v-model="page_type"
          style="width: 150px; margin: 0 8px"
          @on-change="getData"
        >
          <Option :value="0" :key="0">不限</Option>
          <Option :value="1" :key="1">微信</Option>
          <Option :value="2" :key="2">支付宝</Option>
        </Select>
      </div>
      <div style="margin-top: 10px">
        <span class="subtitle">转账日期:</span>
        <DatePicker
          type="date"
          v-model="page.start"
          placeholder="开始时间"
          @on-change="changeDate"
          style="width: 120px; margin-left: 10px"
        ></DatePicker>
        <span style="margin: 0 5px">至</span>
        <DatePicker
          type="date"
          v-model="page.end"
          placeholder="结束时间"
          @on-change="changeDate"
          style="width: 120px"
        ></DatePicker>
        <RadioGroup
          type="button"
          style="margin-left: 10px"
          v-model="radio"
          @on-change="onChangeSelectData"
        >
          <Radio label="0">
            <span>今&nbsp;&nbsp;日</span>
          </Radio>
          <Radio label="1">
            <span>本 月</span>
          </Radio>
          <Radio label="2">
            <span>上 月</span>
          </Radio>
        </RadioGroup>
        <span class="subtitle" style="margin-left: 10px" v-if="!agent.tp"
          >合作伙伴:</span
        >
        <Select
          v-if="!agent.tp"
          v-model="page.agent_id"
          class="item"
          filterable
          style="width: 200px; margin-left: 5px"
          placeholder="请选择"
        >
          <Option
            v-for="(item, index) in agentList"
            :key="index"
            :value="item.id"
            >{{ item.agent_name }}</Option
          >
        </Select>
      </div>
      <div class="bottom">
        <span class="btn-filter" @click="getData(1)">筛选</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button
              type="primary"
              style="margin-right: 5px"
              @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>
    <div style="position: relative">
      <Table
        :columns="columns"
        :data="data"
        :footer-hide="true"
        :loading="tableLoading"
      />
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Modal v-model="visible" width="1130" title="分账明细">
      <Table :columns="detail_columns" :data="detail" ref="table" id="table">
        <template slot-scope="{ row, index }" slot="return_ids">
          <Button
            v-if="row.return_ids"
            size="small"
            type="info"
            @click="getReturnJob(row)"
            >查看更多</Button
          >
        </template>
      </Table>
      <div slot="footer">
        <Button @click="visible = false">关闭</Button>
        <Button type="primary" style="margin-left: 10px" @click="exportDetail"
          >导出报表</Button
        >
      </div>
    </Modal>
    <Drawer
      title="退款记录"
      :width="340"
      :closable="true"
      v-model="drawer"
      :mask-style="{ backgroundColor: 'transparent' }"
      :styles="{ padding: '16px 0' }"
    >
      <Table
        height="400"
        :columns="returns_columns"
        :data="returns"
        :footer-hide="true"
        show-summary
        :summary-method="handleSummary"
      />
    </Drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import { verifyDate } from "@/libs/util";
export default {
  data() {
    return {
      page: {
        p: 0,
        l: 10,
        start: new Date(),
        end: new Date(),
        id: "",
        dispense_name: "",
        dispense_id: "",
        agent_id: "",
      },
      agentList: [],
      radio: "0",
      tableLoading: false,
      page_type: 0,
      total: 0,
      columns: [
        { key: "id", width: 70, title: "编号" },
        {
          key: "create_time",
          title: "转账日期",
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
          width: 140,
        },
        { key: "dispense_account_id", title: "收款人ID", width: 90 },
        { key: "dispense_name", title: "收款人", width: 150 },
        { key: "order_id", title: "分账单号", width: 160 },
        {
          key: "type",
          title: "收款方式",
          render: (h, data) => {
            return h("span", {}, data.row.user_id ? "支付宝" : "微信");
          },
          width: 90,
        },
        { key: "total_extract", width: 100, title: "应转金额" },
        {
          key: "deduction",
          width: 100,
          title: "冲抵金额",
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.deduction ? data.row.deduction.toFixed(2) : "0.00"
            );
          },
        },
        {
          key: "type",
          title: "实转金额",
          width: 120,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.deduction
                ? (data.row.total_extract - data.row.deduction).toFixed(2)
                : data.row.total_extract
            );
          },
        },
        {
          key: "note",
          title: "冲抵说明",
          width: 150,
        },
        { key: "agent_name", title: "合作伙伴", width: 280 },
        {
          key: "status",
          width: 100,
          title: "状态",
          fixed: "right",
          render: (h, data) => {
            // 0未转账 1已转账 2转账失败
            let text = "";
            switch (data.row.status) {
              case 0:
                text = "-";
                break;
              case 1:
                text = "已转账";
                break;
              case 2:
                text = `转账失败(${data.row.err_msg})`;
                break;
              default:
                break;
            }
            return h("span", {}, text);
          },
        },
        {
          key: "operate",
          width: 120,
          title: "操作",
          fixed: "right",
          export_ignore: true,
          render: (h, data) => {
            return h(
              "Button",
              {
                props: { type: "success", size: "small" },
                on: {
                  click: () => {
                    this.GetSettleDetail({ id: data.row.id }).then((res) => {
                      console.log(43, res);
                      this.detail = res;
                      this.visible = true;
                    });
                  },
                },
              },
              "查看明细"
            );
          },
        },
      ],
      data: [],
      detail_columns: [
        { key: "sn", width: 115, title: "设备序列号" },
        { key: "site_name", title: "设备站点" },
        {
          key: "type",
          title: "方向",
          render: (h, data) => {
            return h("span", data.row.type ? "支付宝" : "微信");
          },
        },
        {
          key: "status",
          title: "状态",
          render: (h, data) => {
            // 0未转账 1已转账 2转账失败
            let text = "";
            switch (data.row.status) {
              case 0:
                text = "未转账";
                break;
              case 1:
                text = "已转账";
                break;
              case 2:
                text = `转账失败(${data.row.err_msg})`;
                break;
              default:
                break;
            }
            return h("span", {}, text);
          },
        },
        {
          key: "create_time",
          title: "结算截止",
          render: (h, data) => {
            return h(
              "span",
              {},
              this.$moment(data.row.create_time, "YYYY-MM-DD")
            );
          },
        },
        {
          key: "money",
          title: "金额",
          renderHeader: (h, params) => {
            return h(
              "Tooltip",
              {
                props: { size: "small", placement: "top", transfer: true },
              },
              [
                h("span", [
                  h("span", "金额"),
                  h("Icon", {
                    props: { type: "md-alert", size: 14 },
                    style: {
                      marginLeft: "5px",
                    },
                  }),
                ]),
                h(
                  "span",
                  {
                    slot: "content",
                  },
                  "扣除交易手续费后"
                ),
              ]
            );
          },
        },
        { key: "return_money", title: "退款金额" },
        {
          key: "extract",
          title: "分账比例",
          render: (h, data) => {
            return h("span", data.row.extract + "%");
          },
        },
        { key: "money_extract", title: "结算金额" },
        { key: "return_ids", slot: "return_ids", title: "退款记录" },
      ],
      detail: [],
      visible: false,
      drawer: false,
      returns: [],
      returns_columns: [
        { key: "job_id", width: 90, title: "订单编号" },
        {
          key: "create_time",
          title: "退款时间",
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        { key: "money", width: 90, title: "退款金额" },
      ],
    };
  },
  mounted() {
    this.getData();
    this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.agentList = res.data;
    });
  },
  methods: {
    handleSummary({ columns, data }) {
      let sum = 0;
      data.map((item) => {
        sum += item.money;
      });
      return {
        job_id: { key: "job_id", value: "合计" },
        create_time: { key: "create_time", value: "" },
        money: { key: "money", value: sum },
      };
    },
    getReturnJob(data) {
      this.drawer = true;
      this.GetSettleReturnJob({ id: data.id }).then((res) => {
        this.returns = res;
      });
    },
    exportData(is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: "分账记录",
      };
      this.columns.map((item) => {
        if (item.export_ignore) {
          return;
        }
        params.title.push(item.title);
        params.key.push(item.key);
      });
      if (is_all) {
        let resCond = this.getDataParams();
        resCond.p = 0;
        resCond.l = 10000;
        this.GetSettle(resCond).then((res) => {
          params.data = this.formatExportData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.formatExportData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    formatExportData(data) {
      data.map((item) => {
        item.create_time = this.$moment(item.create_time);
        item.ID = item.user_id ? item.user_id : item.open_id;
        item.type = item.deduction
          ? (item.total_extract - item.deduction).toFixed(2)
          : item.total_extract;
        item.status =
          item.status == 0
            ? "-"
            : item.status == 1
            ? "已转账"
            : `转账失败(${item.err_msg})`;
      });
      return data;
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    getDataParams() {
      try {
        let resCond = {
          start_date: this.$moment(this.page.start, "YYYY-MM-DD"),
          end_date: this.$moment(this.page.end, "YYYY-MM-DD"),
          id: this.page.id,
          dispense_name: this.page.dispense_name,
          dispense_id: this.page.dispense_id,
          p: this.page.p,
          l: this.page.l,
          agent_id: this.page.agent_id,
        };
        if (this.page_type) {
          switch (this.page_type) {
            case 1:
              resCond.type = "open_id";
              break;
            case 2:
              resCond.type = "user_id";
              break;
          }
        }
        return resCond;
      } catch (error) {
        console.log(error);
      }
    },
    getData(filter) {
      if (filter) {
        this.page.p = 0;
      }
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error("开始时间不能大于结束时间");
        return;
      }
      let resCond = this.getDataParams();
      console.log("参数", resCond);
      this.tableLoading = true;
      this.GetSettle(resCond).then((res) => {
        this.tableLoading = false;
        this.total = res.total;
        this.data = res.data;
      });
    },
    exportDetail() {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: "分账明细",
      };
      this.detail_columns.map((item) => {
        params.title.push(item.title);
        params.key.push(item.key);
      });
      let data = JSON.parse(JSON.stringify(this.detail));
      data.map((item) => {
        item.type = item.type ? "支付宝" : "微信";
        item.status =
          item.status == 0
            ? "未转账"
            : item.status == 1
            ? "已转账"
            : `转账失败(${item.err_msg})`;
        item.create_time = this.$moment(item.create_time, "YYYY-MM-DD");
        item.extract = item.extract + "%";
      });
      params.data = data;
      excel.export_array_to_excel(params);
    },
    onChangeSelectData(e) {
      switch (e) {
        case "0": //今日
          let now = new Date();
          this.page.start = this.$moment(now, "YYYY-MM--DD");
          this.page.end = this.$moment(now, "YYYY-MM-DD");
          break;
        case "1": //本月
          this.curMonth(true);
          break;
        case "2": //上月
          this.curMonth();
          break;
      }
    },
    //本月
    curMonth(isCur) {
      let now = new Date();
      let a = isCur ? 1 : 0;
      let last = new Date(now.getFullYear(), now.getMonth() + a, 0);
      this.page.start = this.$moment(last, "YYYY-MM") + "-01";
      this.page.end = this.$moment(last, "YYYY-MM-DD");
    },
    // 重置获取数据
    reset() {
      this.page = {
        p: 0,
        l: 10,
        start: new Date(),
        end: new Date(),
        id: "",
        dispense_name: "",
      };
      this.radio = "0";
      this.getData();
    },
    changeDate() {
      this.radio = "";
    },
    ...mapActions([
      "GetSettle",
      "GetSettleDetail",
      "GetSettleReturnJob",
      "getAgentList",
    ]),
  },
  watch: {
    "date.month"(n, o) {
      this.date.maxDate = new Date(new Date().getFullYear(), n, 0).getDate();
    },
  },
  computed: mapGetters({
    agent: "agent",
  }),
};
</script>

<style lang="less">
.ivu-drawer-wrap {
  z-index: 99999;
}
@import "./index.less";
</style>
